import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入字体的文件
import './assets/font/iconfont.css'
// 引入全局的样式文件
import './assets/css/global.less'

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

import SocketService from '@/utils/socket_service'
// 对服务端进行websocket的连接
SocketService.Instance.connect()
// 其他的组件  this.$socket
Vue.prototype.$socket = SocketService.Instance

import Bus from './utils/bus'
Vue.prototype.$bus = Bus

import axios from 'axios'
// 请求基准路径的配置

//运维演示环境
// axios.defaults.baseURL = 'http://cssp-scr.snca.com.cn/api/'
//研发部测试环境
// axios.defaults.baseURL = 'http://10.10.60.21:9084/api/'

// 将axios挂载到Vue的原型对象上
// 在别的组件中 this.$http
Vue.prototype.$http = axios

// 将全局的echarts对象挂载到Vue的原型对象上
// 别的组件中 this.$echarts
Vue.prototype.$echarts = window.echarts

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
